import Logic from './logic';
import nine from '@/assets/images/9.png';
import eleven from '@/assets/images/11.png';
import twelve from '@/assets/images/12.png';
import Thirteen from '@/assets/images/13.png';
export default function Zero() {
  const { goNext } = Logic();
  return (
    <div className="grid grid-cols-1 gap-2 p-10 ">
      <h1 className="text-center font-bold ">الشروط والأحكام</h1>
      <p className=" text-slate-500"></p>
      <div className="grid grid-cols-1 gap-4 mt-5">
        <span className="font-bold text-sm">
          1. وفقا للتعليمات الصادرة من وزارة الاتصالات - الشركة العامة للاتصالات والمعلوماتية تكون
          مدة عقد المقاول الثانوي سنتان ونصف قابلة للتجديد لمرة واحدة فقط ولمده مماثله، وان شرط
          التجديد يرتبط بالتزام المقاول الثانوي بتنفيذ شبكة ضوئية مدفونة تحت الارض (Underground)
          وحسب المواصفات الفنية المرفقة في هذا الاعلان، اما في حال وجود شبكة ضوئية ثانوية متكاملة
          (من الكابينةFDT، الى العامود (FATفتكون مدة العقد 5 سنوات.
        </span>
        <span className="font-bold text-sm">
          2. يكون اختيار المقاول الثانوي خاضع للتدقيق الامني والموافقات الامنية وحسب الضوابط المعمول
          بها ويتم التأكد من سلامة الموقف الامني والوثائق المقدمة من قبله قبل التعاقد معه.
        </span>
        <span className="font-bold text-sm">
          3. يلتزم المقاول الثانوي الذي سيتم احالة العمل اليه بتنفيذ الشبكة من الكابينة الى المشترك
          النهائي وصيانة هذا الشبكة وحمايتها والترويج للخدمات وجباية الاشتراكات ونصب جهاز الـ ONT
          للمستخدم النهائي.
        </span>
        <span className="font-bold text-sm">
          4. في حاله تلكؤ او نكول المقاول الثانوي وعدم توقيعه للعقد او الاخلال بالتزاماته فيتم اتخاذ
          الأجراءات القانونية بحقه.
        </span>
        <span className="font-bold text-sm">
          5. بعد انتهاء فترة عمل المقاول الثانوي (الفترة الاصلية سنتان ونص وتمديدها الى الخمس سنوات
          في حالة وجود شبكة ثانوية متكاملة) يعاد الاعلان عن المناقصة الخاصة بأستقدام المقاولين
          الثانويين (لغرض التسويق فقط) حسب شروط واليات العمل التي ستنظم لاحقاً. وتكون الأفضلية في
          الاختيار للمقاول الثانوي الذي سيلتزم بالخطة التسويقية والتنفيذية المقدمة من قبله
          والتعليمات الصادرة من شركة الخلية الفائقة والشركة العامة للاتصالات والمعلوماتية.
        </span>
        <span className="font-bold text-sm">
          6. يلتزم المقاول الثانوي بالعمل وفق شروط العقد تحت اشراف الطرف الثاني ووزارة الاتصالات-
          الشركة العامة للاتصالات والمعلوماتية بغية تجهيز ونصب وانشاء شبكة ضوئية وأعمدة من الكابينة
          والواصلة في بداية كل منطقة والعائدة للمشروع والمنفذة عن طريق شركة الخلية الفائقة الى
          المستخدم النهائي وذلك لغرض منع الاحتكار وإيصال الخدمات بجودة عالية واشراك أكبر عدد من
          المشتركين بهذه الخدمة.
        </span>
        <span className="font-bold text-sm">
          7. على المقاول الثانوي الالتزام بالتفعيل وفقا للخطة التسويقية المقدمة.
        </span>
        <span className="font-bold text-sm">
          8. يلتزم المقاول الثانوي بنقل جميع مشتركين العقد الهوائية التابعة له (ان وجد) على كابينة
          الكابل الضوئي خلال الربع الأول من تاريخ استلام الكابينة.
        </span>
        <span className="font-bold text-sm">
          9. يلتزم المقاول الثانوي بتوفير موظفين للكابينات وفقا لأدناه: عدد الموظفين عدد الكابينات{' '}
        </span>
        <img className="h-32" src={nine} alt="" />
        <span className="font-bold text-sm">
          10. على موظفي المقاول الثانوي الالتزام بالزي الرسمي المحدد والمزود من قبل شركة الخلية
          الفائقة.
        </span>
        <span className="font-bold text-sm">
          11. على كادر عمل المقاول الثانوي العمل وفقا لمعايير العمل التي سينص عليها العقد بما في ذلك
          مراعاة معايير خدمة العملاء واتفاقية مستوى الخدمة.
        </span>

        <span className="font-bold text-sm">12. توفير منافذ بيع بما يتطابق مع ادناه:</span>
        <img className="h-24" src={twelve} alt="" />
        <span className="font-bold text-sm">
          13. على المقاول الثانوي الالتزام بأوقات العمل في مراكز البيع وخدمات ما بعد البيع بما لا
          يقل عن ادناه:
        </span>
        <img className="h-14" src={Thirteen} alt="" />
        <span className="font-bold text-sm">
          14. على المقاول الثانوي التعاون مع فرق عمل الطرف الأول فيما يخص الزيارات الميدانية لمراكز
          البيع وخدمات ما بعد البيع في مناطق عمل المقاول الثانوي.
        </span>
        <span className="font-bold text-sm">
          15. على المقاول الثانوي الالتزام بتسجيل جميع المشتركين الكترونيا وفقا للشروط المطلوبة من
          قبل الشركة العامة للاتصالات والمعلوماتية وبموجب الالية التي ستزودها شركة الخلية الفائقة.
        </span>
      </div>
      <button onClick={goNext} className="bg-gray-600 text-slate-100 py-3 rounded-sm mt-2">
        اوافق
      </button>
    </div>
  );
}
